import { Box, ChakraProvider, Grid, theme } from '@chakra-ui/react';
import React from 'react';
import Calculator from './components/Calculator';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Theory from './components/Theory';

function App() {

  return (
    <ChakraProvider theme={theme}>
      <Box textAlign="center" fontSize="xl"
      >
        <Grid minH="100vh" p={0}>
          <Navbar />
          <Calculator />
          <Theory />
          <Footer />
        </Grid>
      </Box>
    </ChakraProvider>
  );
}

export default App;
